import React from 'react';
import ImageModal from '../../Utils/ModalImage';

interface BillingSectionProps {
  title: string;
  description: string;
  currentSituationImage: string;
  teachrImage: string;
}

const BillingSection: React.FC<BillingSectionProps> = ({
  title,
  description,
  currentSituationImage,
  teachrImage
}) => {
  return (
    <div className="md:space-y-10 space-y-4 pt-4 pb-10">
      <h3 className="font-extrabold xl:text-[36px] text-[26px] text-first text-center">
        {title}
      </h3>
      <div className="md:flex md:items-center text-first gap-x-2">
        <div className="md:w-1/2">
          <p className="text-[#808080] xl:text-[24px] lg:text-[20px] text-[18px] md:leading-10 leading-8">
            {description}
          </p>
        </div>
        <div className="md:w-1/2">
          <div className="text-center">
            <ImageModal src={currentSituationImage} alt="Votre situation actuelle" />
            <span className="text-center w-full">
              Votre situation actuelle
            </span>
          </div>
          <div className="text-center">
            <ImageModal src={teachrImage} alt="Avec Teach'r" />
            <span>Avec Teach'r</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingSection; 